var React = require('react');

function Windsock (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M80.05 5.46a55.93 55.93 0 1 0-48.18 101V496a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V106.42a55.87 55.87 0 0 0 .17-101zm112 384.54l64-9V147l-64-9zM352.1 161v206l64-9V170z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M111.89 401.1l80-11.39V138.32l-80-11.4zM498.3 182L416 170.31v187.4l82.33-11.8a15.94 15.94 0 0 0 13.7-15.8v-132.2A16.13 16.13 0 0 0 498.3 182zM255.93 380.61l96-13.7V161.12l-96-13.7z","className":"fa-primary","key":2})]);
}

Windsock.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Windsock;

Windsock.default = Windsock;
